import { CircularProgress, TextField } from '@mui/material';
import Box from '@mui/material/Box/Box';
import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../../../../../application/language/useI18n';
import { IProjectLearningReportArg } from '../../../../../service/report/interface/IProjectLearningReportArg';
import { ProjectRatingsTable } from '../../../shared/ratings/ProjectRatingsTable';
import { ProjectRatingsDomain } from './store/ProjectRatingsDomain';
import { ProjectRatingsUI } from './store/ProjectRatingsUI';

type IProjectRatingsContentProperties = {
  reportArg?: IProjectLearningReportArg;
};

export const ProjectRatingsContent = observer(({ reportArg = {} }: IProjectRatingsContentProperties) => {
  const { translate } = useI18n();
  const [ui] = useState(() => new ProjectRatingsUI(new ProjectRatingsDomain(), reportArg));
  const [searchTerm, setSearchTerm] = useState('');
  const isFirstRender = useRef(true);

  useEffect(() => {
    ui.boot();
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      ui.search(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  return (
    <Box>
      <Box sx={{ mb: 1 }}>
        <TextField
          size="small"
          placeholder={translate('analytics.ratings.projects.searchPlaceholder')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ width: 280 }}
        />
      </Box>
      {ui.isFetching.value ? (
        <Box sx={{ minHeight: '160px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <ProjectRatingsTable rows={ui.rows.list} />
      )}
    </Box>
  );
});
